import Project from "@/models/SvcModels/Project";
import Parcel from "./Parcel";

export default class Mission extends Project {
  static entity = "missions";
  static primaryKey = "chronorapso";

  static fields() {
    return {
      ...super.fields(),
      uuid: this.uid(""),
      name: this.string(""),
      description: this.string(""),
      status: this.string(""),
      createdAt: this.attr(null),
      updatedAt: this.attr(null),
      globalMission: this.attr(null),
      elementaryMissions: this.attr([]),
      isImported: this.boolean(false),
      importedFrom: this.string(""),
      dictDate: this.string(""),
      reportingDate: this.string(""),
      commandeDate: this.string(""),
      visitDate: this.string(""),
      secondVisitDate: this.string(""),
      visitContributor: this.string(""),
      secondVisitContributor: this.string(""),
      dashboardUuid: this.uid(""),
      siteArea: this.number(0),
      parcelCount: this.number(0),
      parcel: this.hasMany(Parcel, "project"),
      aosSite: this.string(""),
      conclusion: this.string(""),
      eurofinsQuotation: this.attr(null),
    };
  }
}
